export default __webpack_public_path__ + "static/security-e57a77adcdbb107919dbeebba92fc234.jpg";